import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


const Header = () => {

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isDropdownSecond, setIsDropdownSecond] = useState(false);


    const toggleMenus = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = (e) => {
        e.preventDefault();
        setIsDropdownOpen(!isDropdownOpen);
    };

    const toggleDropdownSecond = (e) => {
        e.preventDefault();
        setIsDropdownSecond(!isDropdownSecond);
    };

    // Close the dropdown when a link is clicked
    const closeDropdown = () => {
        setIsDropdownOpen(false);
    };

    return (
        <>

            {/* <Helmet>
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-SF6QWQV2FR"></script>
                <script>
                    {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-SF6QWQV2FR');
          `}
                </script>
            </Helmet> */}

            <nav>
                <div class="container">
                    <div className="navbar-logo">
                        <div className="logo">
                            <Link to="/"><img src={require('../assets/images/logo (1).webp')} alt="Logo" /></Link>
                        </div>

                        {/* Mobile Button */}
                        <div className="mobile_btn" onClick={toggleMenus}>
                            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i> {/* Switch icons based on state */}
                        </div>

                        {/* Main Menu */}
                        <div className={`main_menu mt-2 ${isMenuOpen ? 'active' : ''}`}>
                            <ul>
                                <li><Link to="/" className="active">Home</Link></li>
                                <li><Link to="/about" className="active">About Us</Link></li>
                                <li className={`has_dropdown ${isDropdownOpen ? 'active' : ''}`} onClick={toggleDropdown}>
                                    <a href="#">Customer 360</a>
                                    {isDropdownOpen && (
                                        <ul className="sub_menu sales_cloud">
                                            <li className="mt-3"><img src={require('../assets/images/header/s-1.webp')} alt="" className="icons" /> <Link to="/salesforce/sales-cloud" onClick={closeDropdown}>Salesforce Sales Cloud</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/s-2.webp')} alt="" className="icons" /><Link to="/salesforce/service-cloud" onClick={closeDropdown}>Salesforce Service Cloud</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/s-3.webp')} alt="" className="icons" /><Link to="/salesforce/marketing-cloud" onClick={closeDropdown}>Salesforce Marketing Cloud</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/s-4.webp')} alt="" className="icons" /><Link to="/salesforce/commerce-cloud" onClick={closeDropdown}>Salesforce Commerce Cloud</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/s-5.webp')} alt="" className="icons" /><Link to="/salesforce/community-cloud" onClick={closeDropdown}>Salesforce Community Cloud</Link></li>
                                            <li className="mt-3 mb-4"><img src={require('../assets/images/header/s-6.webp')} alt="" className="icons" /><Link to="/salesforce/non-profit" onClick={closeDropdown}>Salesforce Non-Profit</Link></li>
                                        </ul>
                                    )}
                                </li>
                                <li className={`has_dropdown ${isDropdownSecond ? 'active' : ''}`} onClick={toggleDropdownSecond}>
                                    <a href="#">Our Expertise</a>
                                    {isDropdownSecond && (
                                        <ul className="sub_menu sales_cloud">
                                            <li className="mt-3"><img src={require('../assets/images/header/t-1.webp')} alt="" className="icons" /> <Link to="/salesforce/development" onClick={closeDropdown}>Salesforce Development</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/t-2.webp')} alt="" className="icons" /><Link to="/salesforce/implementation" onClick={closeDropdown}>Salesforce Implementation</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/t-3.webp')} alt="" className="icons" /><Link to="/salesforce/customization" onClick={closeDropdown}>Salesforce Customization</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/t-4.webp')} alt="" className="icons" /><Link to="/salesforce/integration" onClick={closeDropdown}>Salesforce Integration</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/t-5.webp')} alt="" className="icons" /><Link to="/salesforce/consulting" onClick={closeDropdown}>Salesforce Consulting</Link></li>
                                            <li className="mt-3"><img src={require('../assets/images/header/t-6.webp')} alt="" className="icons" /><Link to="/salesforce/maintenance" onClick={closeDropdown}>Salesforce Maintenance</Link></li>
                                            <li className="mt-3 mb-4"><img src={require('../assets/images/header/t-7.webp')} alt="" className="icons" /><Link to="/salesforce/support" onClick={closeDropdown}>Salesforce Support</Link></li>
                                        </ul>
                                    )}
                                </li>
                                <li><Link to="/case-study">Case Studies</Link></li>
                                <li className="header_shadow"><Link className="text-white" to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>


        </>
    )
}

export default Header;

{/* <div class="main_menu mt-2">
    <ul>
        <li><Link to="/" class="active">Home</Link></li>
        <li><Link to="/" class="active">About Us</Link></li>
        <li class="has_dropdown"><a href="#">Services <i class="fas fa-angle-down"></i></a>
            <ul class="sub_menu">
                <li><a href="#">Salesforce</a></li>
                <li class="has_dropdown"><a href="#">Page 2 <i class="fas fa-angle-right"></i></a>
                                            <ul class="sub_menu">
                                                <li><a href="#">Page 2.1</a></li>
                                                <li><a href="#">Page 2.2</a></li>
                                                <li class="has_dropdown"><a href="#">Page 2.3 <i class="fas fa-angle-right"></i></a>
                                                    <ul class="sub_menu">
                                                        <li><a href="#">Page 2.1</a></li>
                                                        <li><a href="#">Page 2.2</a></li>
                                                        <li><a href="#">Page 2.3</a></li>
                                                        <li><a href="#">Page 2.4</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="#">Page 2.4</a></li>
                                            </ul>
                                        </li>
                <li><a href="#">Salesforce</a></li>
                <li><a href="#">Salesforce</a></li>
                <li><a href="#">Salesforce</a></li>
            </ul>
        </li>
        <li class="mega_menu_dropdown has_dropdown">
                                    <a href="#">Shop <i class="fas fa-angle-down"></i></a>
                                    <div class="mega_menu sub_menu">
                                        <div class="mega_menu_item">
                                            <img src="https://via.placeholder.com/250x300" />
                                        </div>
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                    </div>
                                </li>
        <li class="mega_menu_dropdown mega_menu_demo_2 has_dropdown">
                                    <a href="#">Shop 2 <i class="fas fa-angle-down"></i></a>
                                    <div class="mega_menu sub_menu">
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                        <div class="mega_menu_item">
                                            <h3>Theme Elements</h3>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                            <a href="#">Mega menu item</a>
                                        </div>
                                    </div>
                                </li>
        <li><a href="#">Case Studies</a></li>
        <li><a href="#">Contact</a></li>
    </ul> */}